<p>
  {{ 'STEP3.INTRODUCTIONTEXT' | translate }}
</p>
<Label>{{ 'STEP3.WIDTHINTERNAL' | translate }}</Label>
<app-step-three-slider
  [selectId]="'width-slider'"
  #widthSlider
  [max]="maxWidth"
  [min]="900"
  [step]="300"
  [(value)]="width"></app-step-three-slider>
<Label>{{ 'STEP3.LENGTHINTERNAL' | translate }}</Label>
<app-step-three-slider
  [selectId]="'length-slider'"
  #lengthSlider
  [max]="maxLength"
  [min]="900"
  [step]="300"
  [(value)]="length"></app-step-three-slider>
<Label>{{ 'STEP3.HEIGHTINTERNAL' | translate }}</Label>
<app-step-three-slider
  [selectId]="'height-slider'"
  #heightSlider
  [max]="3900"
  [min]="1800"
  [step]="300"
  [(value)]="height"></app-step-three-slider>
